import React from 'react';
import TableCellEdit from '../table/components/TableCellEdit.component';
import logbook from '../../module/logbook';
import { API } from '../../module/logbook/api';
import { Grid, Stack } from '@mui/material';
import AsyncAutocomplete from '../form/components/AsyncAutocomplete.component';
import { API as users_nautica } from '../../module/users_nautica/api';
import PersonIcon from '@mui/icons-material/Person';
import MuiTypography from '@mui/material/Typography';
import { PERMISSION_DRIVER_EDIT } from '../../module/logbook/conf/Data.conf';
import { useSelector } from 'react-redux';

export const DriverLogbookEdit = ({ value, onClick }) => {
  const userAuth = useSelector((state) => state?.login?.user);
  return (
    <TableCellEdit
      hasPermission={PERMISSION_DRIVER_EDIT.includes(userAuth.department)}
      module={{
        ...logbook,
        query: {
          ...logbook.query,
          edit: { settings: API.updateFromList },
        },
      }}
      value={{
        id: value?.id_operation,
        id_driver_in_charge: value?.id_driver_in_charge,
      }}
      name={'id_driver_in_charge'}
      form={
        <Grid item xs={12} sm={12}>
          <AsyncAutocomplete
            id='id_driver_in_charge'
            label='Driver in charge'
            name='id_driver_in_charge'
            value={
              value?.id_driver_in_charge
                ? {
                    id: value?.id,
                    name: `${value?.id_driver_in_charge?.name} ${value?.id_driver_in_charge?.surname}`,
                  }
                : null
            }
            api={users_nautica.drivers}
          />
        </Grid>
      }
    >
      {value?.id_driver_in_charge ? (
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <PersonIcon color='action' fontSize='small' />
          <MuiTypography sx={{ height: 1 }} variant='body1' onClick={onClick}>
            {value?.id_driver_in_charge?.name}{' '}
            {value?.id_driver_in_charge?.surname}
          </MuiTypography>
        </Stack>
      ) : (
        '-'
      )}
    </TableCellEdit>
  );
};

export default DriverLogbookEdit;
